module.exports = __webpack_public_path__ + "media/images/icon/allow_blue-16f9a6a4e5f1735d65dab16bc08da47c.png";